import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import type { FunnelData } from "../../types";
interface FontSettingsProps {
  data: FunnelData;
  onUpdate: (updates: Partial<FunnelData>) => void;
  LOGO_FONTS: Array<{
    value: string;
    label: string;
    className: string;
  }>;
  FONT_SIZES: Array<{
    value: string;
    label: string;
  }>;
  FONT_WEIGHTS: Array<{
    value: string;
    label: string;
  }>;
}
export const FontSettings = ({
  data,
  onUpdate,
  LOGO_FONTS,
  FONT_SIZES,
  FONT_WEIGHTS
}: FontSettingsProps) => {
  return <div className="grid grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label>Betütípus</Label>
        <Select value={data.logoConfig?.font || "roboto"} onValueChange={value => onUpdate({
        logoConfig: {
          ...data.logoConfig,
          font: value
        }
      })}>
          <SelectTrigger>
            <SelectValue placeholder="Select font" />
          </SelectTrigger>
          <SelectContent>
            {LOGO_FONTS.map(font => <SelectItem key={font.value} value={font.value} className={font.className}>
                {font.label}
              </SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label>Betűméret</Label>
        <Select value={data.logoConfig?.fontSize || "text-xl"} onValueChange={value => onUpdate({
        logoConfig: {
          ...data.logoConfig,
          fontSize: value
        }
      })}>
          <SelectTrigger>
            <SelectValue placeholder="Select size" />
          </SelectTrigger>
          <SelectContent>
            {FONT_SIZES.map(size => <SelectItem key={size.value} value={size.value}>
                {size.label}
              </SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label>Betű vastagság</Label>
        <Select value={data.logoConfig?.fontWeight || "font-normal"} onValueChange={value => onUpdate({
        logoConfig: {
          ...data.logoConfig,
          fontWeight: value
        }
      })}>
          <SelectTrigger>
            <SelectValue placeholder="Select weight" />
          </SelectTrigger>
          <SelectContent>
            {FONT_WEIGHTS.map(weight => <SelectItem key={weight.value} value={weight.value} className={weight.value}>
                {weight.label}
              </SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    </div>;
};